import SalaryPageTemplate from "@/components/SalaryPageTemplate";
import { SALARY_DATA } from "@/data/salaryData";

export default function UXDesignerSalary() {
  return <SalaryPageTemplate data={SALARY_DATA["ux-designer"]} />;
}
